<template>
  <div>
    <div class="main-container">
      <div class="nav">
        <span>
          Payroll > Manage paygroups >
          <b>Add Paygroups</b>
        </span>
      </div>
      <tl-header type="h1">
        <div>Pay Groups</div>
        <template slot="icon">
          <!-- <div class="row-container">
            <img src="@/assets/logout-copy-2.svg" class="logout-copy-2">
            <button class="export-button">Upload</button>
            <div class="showIntro" @click="goToIntro">
              <img src="@/assets/questionmark.png">
            </div>
          </div>-->
        </template>
      </tl-header>
      <txt
        autofocus="autofocus"
        class="payGroup-field"
        label="Pay Group Name"
        type="text"
        v-model="formData.payGroupName"
        placeholder="Enter Name"
        name="Pay Group Name"
      />
      <div class="criteria-field">
        <div class="label-text">Criteria</div>
        <tl-checkbox
          class="headcheck checkBox"
          label="Location"
          v-model="formData.location"
          @change="changeHandler"/>
        <div v-if="formData.location">
          <div class="sub-checkbox" v-for="(location,index) in locations" :key="index">
            <tl-checkbox class="headcheck checkBox" :label="location" v-model="sub_location"/>
          </div>
        </div>
        <tl-checkbox class="headcheck checkBox" label="Pay Bands" v-model="formData.payBand"/>
        <div v-if="formData.payBand">
          <div class="sub-checkbox" v-for="(band,index) in payBands" :key="index">
            <tl-checkbox class="headcheck checkBox" :label="band" v-model="sub_band"/>
          </div>
        </div>
        <tl-checkbox class="headcheck checkBox" label="Designation" v-model="formData.designation"/>
        <div v-if="formData.designation">
          <div class="sub-checkbox" v-for="(designation,index) in designations" :key="index">
            <tl-checkbox class="headcheck checkBox" :label="designation" v-model="sub_band"/>
          </div>
        </div>
        <txt
          autofocus="autofocus"
          class="payGroup-field"
          label="Description"
          v-model="formData.description"
          type="textarea"
          rows="6"
          placeholder="Enter Name"
          name="Pay Group Name"
        />
        <pop-up-message v-if="showSuccessMsg"
        :message="`PayGroup has been successfully added.`"
        btnText="Back To PayGroup"
        @back="backfrompopup()"/>
        <footer>
          <toast-message :message="errmsg" v-show="toast" type="error"/>
          <bottom-action-container>
            <btn-grp slot="end">
              <btn text="Back" type="secondary" @click="goBackToPayGroup" />
              <btn text="Add Pay Group" type="primary" class @click="addPayGroup"></btn>
            </btn-grp>
          </bottom-action-container>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions,mapGetters } from 'vuex';
export default {
  computed:{
    ...mapGetters({
      record: "dashboard/payroll/monthlypayroll/payGroup/record",
      editMode:"dashboard/payroll/monthlypayroll/payGroup/editMode"
    }),
  },
  data() {
    return {
      formData:{
        location: false,
        payBand: false,
        designation: false,
        payGroupName: "",
        description: ""
      },
      sub_location:'',
      errmsg: "",
      showSuccessMsg:false,
      toast: false,
      selectedLocationList:[],
      selectedPayBandsList:[],
      selectedDesignationList:[],
      locations: ["SouthBangalore", "NorthBangalore", "Hebbal"],
      payBands: ["Band A", "Band B", "Band C"],
      designations: ["Project Manager", "Designation1", "Designation2"]
    };
  },
  activated() {
    this.formData.payGroupName = this.record.groupName;
  },
  methods: {
    ...mapActions({
        act_create:'dashboard/payroll/monthlypayroll/payGroup/create',
        act_update:'dashboard/payroll/monthlypayroll/payGroup/update',
        act_delete:'dashboard/payroll/monthlypayroll/payGroup/delete'
    }),
    goBackToPayGroup(){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/monthlypayroll/paygroupDetails`
      });
    },
    changeHandler(){
      this.formData.location = event.target.value;
      //console.log('location value',this.formData.location,event);
    },
    backfrompopup(){
      this.showSuccessMsg = false;
      this.goBackToPayGroup();
    },
    async performAction() {
        let data = {
          'name':this.formData.payGroupName,
          'description':this.formData.description,
          'location':this.selectedLocations(),
          'salaryBand':this.selectedPayBands(),
          'designation':this.selectedDesignations()
        }
      try {
        this.$root._data.isSaving = true;
        let res = await this.act_create({
          ...data
        });
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
        this.formData = {}
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    addPayGroup(){
      //console.log('addPayGroupPayLoad',this.formData);
      this.$validator.validateAll().then(result => {
        if (result) {
          //console.log("perform signup", result);
          this.performAction().then(() => {
            this.showSuccessMsg = true;
          });
        }
      });
    },
    selectedLocations(){
      return this.locations;
    },
    selectedPayBands(){
      return this.payBands;
    },
    selectedDesignations(){
      return this.designations;
    },
    mapAddress() {

    }
  }
};
</script>


<style lang="scss" scoped>
.sep {
  background-color: #34c0be;
  height: 2px;
  margin-top: 8px;
  border-color: #34c0be;
  border-style: solid;
  /* margin-bottom: 15px; */
}
.checkBox {
  padding: 20px 0px;
}
.criteria-field {
  margin: 20px 0px;
  .label-text {
    font-size: 13px;
    color: #7c7c7c;
    margin-bottom: 4px;
  }
}
.main-container {
  width: 100%;
  padding: 20px 15px;
}
.sub-checkbox {
  margin: 0 40px;
}
.mr-bt-17 {
  margin-bottom: 17px;
}
.tl-textfield {
  .label {
    font-size: 13px;
    color: #7c7c7c;
  }
}
.content-new {
  margin: 32px 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
    // padding-top: 1px
  }
}
.row-container {
  justify-content: flex-end;
}
.nav {
  margin-bottom: 1.7%;
  color: #555555;
  font-size: 12px;
}
.pull-right {
  text-align: right;
}
.text-green {
  color: #34c0be;
  font-weight: bold;
}

.download-btn {
  margin: 15px 0px;
}
.enable-button {
  width: 13%;
  height: 35px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 2px solid #5d409f;
  color: #5d409f;
  margin-left: 42%;
}
.tablesep {
  background-color: #34c0be;
  height: 2px;
  margin-top: 8px;
  border-color: #34c0be;
  border-style: solid;
  margin-bottom: 15px;
}

.buttondis {
  margin-left: auto;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.pull-right {
  width: 100%;
  text-align: right;
}

.disablebtn {
  align-items: center;
  display: flex;
  width: 100%;
  margin-bottom: 10px;
}
.top-heading {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 54px;
  background-color: #f5f6fa;

  .spacing {
    margin-left: 10px;
    grid-column-gap: 110%;
  }
}

.top-heading p {
  font-weight: bold;
  margin-top: 16px;
}

.placeAtEnd {
  margin-top: 130px;
}
.showIntro {
  cursor: pointer;
}
p {
  margin-top: 16px;
}
</style>
